import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { Subscription } from 'rxjs';
import { EventTypes } from 'src/app/core/enums/event.enum';
import { PageState } from 'src/app/core/models/page-state/page-state.model';
import { LoginService } from 'src/app/core/services/login/login.service';
import { PageStateService } from 'src/app/core/services/onboarding/page-state.service';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { reloadApp } from 'src/app/core/ui-helpers/functions/redirect/reload-app';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  signupState: PageState;
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'primary',
    size: <LoaderSize>'large',
  };
  page: string;
  source: string;
  showLogoutContainer = false;

  constructor(
    private router: Router,
    private ps: PageStateService,
    private route: ActivatedRoute,
    private ls: LoginService
  ) {}

  async ngOnInit(): Promise<void> {
    setTimeout(() => {
      this.showLogoutContainer = true;
    }, 20000);

    await this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        this.page = params['page'];
        this.source = params['source'];
      }),
      this.route.data.subscribe(async (data) => {
        this.signupState = await this.ps.getPageStateByEventAndTransitions(
          EventTypes.SIGN_UP,
          data['data']
        );
      })
    );
    this.router.navigate(
      [this.router.createUrlTree([this.signupState.pageUrl]).toString()],
      {
        queryParams: {
          stateId: this.signupState.id,
          page: this.page,
          source: this.source,
        },
      }
    );
    return;
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  async logout() {
    this.subscriptions.push(
      this.ls.logout().subscribe((res: any) => {
        if (res === true) {
          reloadApp(environment);
        }
      })
    );
  }
}
